import { Popover, PopoverContent, PopoverTrigger, RadioGroup, RadioGroupItem } from '@ibsys/kit';
import { ALargeSmallIcon } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CHAT_FONT_SIZE_VIEWS } from '../../models/chatFontSizeViews';
import { CHAT_FONT_SIZES, type ChatFontSize } from '../../models/types';
import { useChatFontSize } from '../../models/useChatFontSize';
import { IconButton } from '@/shared/ui';

/**
 * Кнопка шапки блока «Диалог»: выбор размера шрифта ленты. Перечень размеров открывается окном,
 * выбранный отмечен, а каждый вариант подписан тем размером, который задаёт, — выбор применяется
 * к ленте сразу, без подтверждения.
 */
export const ChatFontSizeButton: FC = () => {
  const { t } = useTranslation(['dialogs']);
  const { chatFontSize, setChatFontSize } = useChatFontSize();

  return (
    <Popover>
      <IconButton
        size="icon"
        label={t('dialogs:chatFontSize.title')}
        icon={<ALargeSmallIcon className="size-4" />}
        trigger={PopoverTrigger}
      />
      {/* Окно — по ширине самой длинной подписи: каждый вариант, в том числе самый крупный, в одну строку */}
      <PopoverContent className="w-max" align="end">
        <RadioGroup
          className="flex flex-col gap-2"
          value={chatFontSize}
          onChange={(size: ChatFontSize) => setChatFontSize(size)}
        >
          {CHAT_FONT_SIZES.map((size) => (
            <RadioGroupItem key={size} value={size}>
              <span className={CHAT_FONT_SIZE_VIEWS[size].textClassName}>{t(CHAT_FONT_SIZE_VIEWS[size].labelKey)}</span>
            </RadioGroupItem>
          ))}
        </RadioGroup>
      </PopoverContent>
    </Popover>
  );
};
